import { Adresse } from "@/model/Adresse";

export class Partner {
  partnernummer = "";
  typ = "";
  anrede = "";
  titel = "";
  vorname = "";
  nachname = "";
  organisation = "";
  email = "";
  telefon = "";
  fax = "";
  mobil = "";
  adresse = new Adresse();
  abweichendeAdresse = new Adresse();
  geburtsdatum = "";
  artDerPartnerschaft = 0;
  hugMitgliedNummer = "";
  hugMitgliedOrt = "";
  nachricht = "";
}
